import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { redirectToOld,isProUser } from '__utils/common-utils';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import { browseMutualFunds } from './home-constants';

import './index.css';

const BrowseFunds: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });

    const [showMoreDetails, setShowMoreDetails] = useState(false);
    
    const filteredMutualFunds = browseMutualFunds.filter(mfCategory => {
        if (mfCategory.title === "LOAN AGAINST MF") {
            return isProUser();
        }
        return true;
    });

    const onMFcategoryClick = (mfCategory: any) => {
        if (mfCategory?.externalRedirect){
            const partner = sessionStorage.getItem('agentCodeMintpro');
            Mixpanel.track(getEventName('LAMF-Category','clicked','home'));
            window.open(`${mfCategory?.redirectUrl}?partnerId=${partner}`);
        } else {
            Mixpanel.track(getEventName('viewMutualFundsCategory', 'clicked', 'home'));
            redirectToOld(mfCategory?.redirectUrl);
        }
    }


    return (
      <div id="Browse">
        {/* Browse Funds by Category section */}
        {!isMobile && (
          <p className="ft24 text-center mt44 bold">Browse Funds by Category</p>
        )}

        <div className="browse-card mint-card-grid">
          {filteredMutualFunds
            // .slice(0, showMoreDetails ? (isMobile ? 8 : 7) : isMobile ? 4 : 6)
            .map((mfCategory: any, index: number) => (
              <div
                key={index}
                className={`${!isMobile ? "mint-box p24" : "p0"}`}
                onClick={() => onMFcategoryClick(mfCategory)}
              >
                <div className="mint-gridHome">
                  <img src={mfCategory.icon} alt="" />
                  <div className="lineH-browse">
                    <p
                      className={`mint-title ${
                        isMobile ? "" : "text-uppercase"
                      }`}
                    >
                      {isMobile ? mfCategory?.mobileTitle : mfCategory?.title}
                    </p>
                    {!isMobile && (
                      <p className="gry-txt">{mfCategory?.description}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>

        {!isMobile && (
          <div className="disclaimer">
            <p>
              *Tax savings of Rs. 46,800/- is calculated assuming that the investor
              has invested INR 1.5 lakh under Section 80C of the Income Tax Act,
              1961, and are subject to amendment from time to time. Tax saving
              component is available only with ELSS Mutual Funds.
            </p>
          </div>
        )}
        {/* <div className="showAll">
            <p onClick={() => setShowMoreDetails(showMoreDetails => !showMoreDetails)}>
                {showMoreDetails ? 'Show less' : 'Show all'} 
                <i className={showMoreDetails ? "icon-arrow_up" : "icon-arrow_down"} />
            </p>
        </div> */}
      </div>
    );

}
export default BrowseFunds;

